import { jsx } from 'react/jsx-runtime';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden.es.js';

const root = "_root_1r8l6_1";
const spin = "_spin_1r8l6_1";
const styles = {
	root: root,
	spin: spin
};

const Spinner = ({ "aria-label": ariaLabel = "Loading", color = "dark", size = "small" }) => {
  return jsx("div", { className: styles.root, "data-testid": "spinner", role: "status", "data-zds": true, "data-color": color, "data-size": size, children: jsx(VisuallyHidden, { children: ariaLabel }) });
};

export { Spinner };
//# sourceMappingURL=Spinner.es.js.map
